import { FC } from 'react';
import cn from 'classnames';
import { Progress } from 'antd';
import {
    CheckCircleFilled,
    CloudUploadOutlined,
    WarningFilled,
} from '@ant-design/icons';

import { PROGRESS_CIRCLE, PROGRESS_COLORS } from '../constants';
import type { UploadVisualState } from '../types';
import styles from '../FileUploader.module.scss';

interface StatusIconProps {
    visualState: UploadVisualState;
    progress: number;
}

export const StatusIcon: FC<StatusIconProps> = ({ visualState, progress }) => {
    if (visualState === 'uploading') {
        const safePercent = Math.max(0, Math.min(progress, 100));

        return (
            <div className={styles.progressBadge}>
                <Progress
                    type="circle"
                    width={PROGRESS_CIRCLE.width}
                    strokeWidth={PROGRESS_CIRCLE.strokeWidth}
                    percent={safePercent}
                    strokeColor={{
                        '0%': PROGRESS_COLORS.start,
                        '100%': PROGRESS_COLORS.end,
                    }}
                    trailColor={PROGRESS_COLORS.trail}
                    strokeLinecap="round"
                    format={() => `${Math.round(safePercent)}%`}
                />
            </div>
        );
    }

    if (visualState === 'success') {
        return (
            <div className={cn(styles.statusBadge, styles.statusSuccess)}>
                <CheckCircleFilled className={styles.statusIcon} />
            </div>
        );
    }

    if (visualState === 'error') {
        return (
            <div className={cn(styles.statusBadge, styles.statusError)}>
                <WarningFilled className={styles.statusIcon} />
            </div>
        );
    }

    return (
        <div className={cn(styles.statusBadge, styles.statusIdle)}>
            <CloudUploadOutlined />
        </div>
    );
};
